import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient } from "./api";

const MenuContext = createContext({
  menu: [],
  menuById: {},
  loading: true,
  refresh: async () => {},
});

export function MenuProvider({ children }) {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (force = false) => {
    setLoading(true);
    try {
      const res = await apiClient.get(`/menu${force ? "?refresh=true" : ""}`);
      setMenu(res.data.items || []);
    } catch (e) {
      // keep prior menu on failure
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const menuById = menu.reduce((acc, m) => {
    acc[m.id] = m;
    return acc;
  }, {});

  return (
    <MenuContext.Provider value={{ menu, menuById, loading, refresh }}>
      {children}
    </MenuContext.Provider>
  );
}

export const useMenu = () => useContext(MenuContext);

export const formatINR = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
